import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { labels, reasons } from './constants'

const ReasonSelector = ({ onChange, selectedReason, status }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      handleChange={onChange}
      fullWidth
      value={selectedReason}
      label={t(labels[status])}
      placeholder={t('Selecciona un motivo')}
      backgroundColor="white"
      menuItems={reasons[status]?.map(r => ({ label: t(r.label), value: r.value }))}
    />
  )
}

export default ReasonSelector
